import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import HierarchicalList from 'Views/Page/Content/Templates/HierarchicalViewTemplate/MainPanel/HierarchicalList';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';

const useStyles = buildUseStyles('MainPanel', ((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
})));

const MainPanel = () => {
  const { displayErrorMessage } = useSnackbarContext();
  const { pageContentCollection } = usePageContentContext();
  const { loadModalCollectionByLink } = useModalContext();

  const classes = useStyles();
  return (
    <Box
      className={classes.root}
    >
      <HierarchicalList
        collection={pageContentCollection}
        onClickItem={(resource) => {
          const itemRelationship = resource.relationship(fr.relationships.item.name);
          if (itemRelationship) {
            loadModalCollectionByLink(itemRelationship.link('related').url());
          } else {
            displayErrorMessage('Unable to edit. Missing required relationship');
          }
        }}
      />
    </Box>
  );
};

export default MainPanel;
